<template>
  <li class="calendar-month-section no-border calendar-day-of-week">
    <p
      class="calendar-week-header calendar-day-of-week__date"
      :class="{
        calendar_active_day:
          new Date().toDateString() === new Date(+day.date).toDateString(),
      }"
    >
      {{ new Date(+day.date).getDate() }}
    </p>
    <div class="calendar-sorting__date-month d-md-none">
      <p
        class="calendar-sorting__date-month_text calendar-sorting__date-week_text right"
        :class="{
          calendar_active_day:
            new Date().toDateString() === new Date(+day.date).toDateString(),
        }"
      >
        {{ new Date(+day.date).getDate() }},
        {{ dayOfWeek }}
      </p>
    </div>
    <ol class="list-unstyled">
      <li v-for="(eventsOfCompany, index) of eventsOfCompanies" :key="index">
        <h6 class="calendar-day-of-month__ticker calendar-day-of-week__ticker">
          {{ eventsOfCompany.companyName | shortText(tickerLength[$mq], '…') }}
        </h6>
        <ol class="list-unstyled">
          <li v-for="(event, index) of eventsOfCompany.events" :key="index">
            <a
              :href="event.link"
              class="calendar-week-header calendar-day-of-week__title"
            >
              {{ event.title }}
            </a>
          </li>
        </ol>
      </li>
    </ol>
  </li>
</template>

<script>
import filters from '@/utils/filters'
import { dividendText } from './MonthDayOpened.vue'

export default {
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      //company name query-dependent length for shortText filter
      tickerLength: { md: 50, lg: 9, xl: 12, xxl: 18, xxxl: 22 },
    }
  },
  methods: { dividendText },
  computed: {
    //computed array that contains objects like {companyName: 'name_of_companyName', events: ['title_of_event_1', 'title_of_event_2', ...]}
    eventsOfCompanies() {
      let array = []
      //get companyNames and titles of events from array day.events
      for (let event of this.day.events) {
        //find in array object with the same companyName of the event
        //will return that object or 0, if the companyName not found
        let res =
          array.find(
            (eventOfArray) =>
              eventOfArray.companyName ===
              event[`CompanyName_${this.$i18n.locale}`]
          ) || 0
        if (res) {
          //check the same event on another market
          if (
            !res.events.find((eventOfArray) => eventOfArray.id === event.id)
          ) {
            //push event in array of events of that companyName
            res.events.push({
              title:
                event.cat === 'div'
                  ? this.$t('calendar.events.type.div', [dividendText(event)])
                  : event[`title_${this.$i18n.locale}`],
              id: event.id,
              link:
                event.cat === 'div'
                  ? `/dashboard/` +
                    event.tickername
                      .split(':')
                      .reverse()
                      .join('/')
                  : event.link,
            })
          }
        } else {
          //else make new object with companyName and event
          let obj = {
            companyName: event[`CompanyName_${this.$i18n.locale}`],
            events: [
              {
                title:
                  event.cat === 'div'
                    ? this.$t('calendar.events.type.div', [dividendText(event)])
                    : event[`title_${this.$i18n.locale}`],
                id: event.id,
                link:
                  event.cat === 'div'
                    ? `/dashboard/` +
                      event.tickername
                        .split(':')
                        .reverse()
                        .join('/')
                    : event.link,
              },
            ],
          }
          //and push it in array
          array.push(obj)
        }
      }
      return array
    },
    dayOfWeek() {
      return this.$t(`calendar.header.daysOfWeekFull[
        ${
          new Date(+this.day.date).getDay() === 0
            ? 6
            : new Date(+this.day.date).getDay() - 1
        }
      ]`)
    },
  },
  filters: {
    shortText: filters.shortText,
  },
}
</script>

<style lang="scss">
.calendar-day-of-week {
  &__date {
    margin-top: 0.53333rem;
    font-weight: bold;
    color: $title-color;
  }
  &__ticker {
    margin-top: 0.73333rem;
    color: #9d9dbc;
    font-weight: normal;
  }
  &__title {
    margin-top: 0.73333rem;
    color: $title-color;
    line-height: 1.06666rem;
    font-size: 0.8rem;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
    &:nth-of-type(7n),
    &:nth-of-type(7n - 6) {
      width: 100%;
    }
    &__date {
      display: none;
    }
    &__ticker {
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 12px;
      text-align: left;
    }
    &__title {
      font-size: 12px;
      text-align: left;
      margin: 19px 0;
    }
  }
}
@media (max-width: 768px) {
  .calendar-sorting__date-week {
    &_text {
      &.right {
        width: 100%;
        position: static;
        padding-top: 2px;
        padding-bottom: 4px;
      }
      &-left {
        color: $primary-color2;
        display: inline;
      }
    }
  }
  .calendar-week-list .calendar_not_active {
    display: none;
  }
}
.no-border {
  border: none;
}

#app[data-theme='dark'] {
  .calendar-day-of-week__date {
    color: #fff;
  }
}
</style>
